package ru.it_mozaika.components


import mui.material.*
import react.FC
import react.Props
import react.ReactNode
import react.create


external interface ButtonComponentProps: Props{
    var onButtonClick: () -> Unit
    var buttonColor: ButtonColor
    var label: String
    var isDisabled: Boolean

}

val commonButtonComponent = FC<ButtonComponentProps> { props->

    Button{
        disabled = props.isDisabled
        color = props.buttonColor
        variant = ButtonVariant.contained
        this.size  = Size.medium
        this.onClick = {
            props.onButtonClick()
        }
        + props.label
    }
}